module.exports = __webpack_public_path__ + "img/mind_background_9.626fa9fa.png";